/**
 * Return true of date is older than 24hr from now.
 * @param ts a number of time in epoch.
 */
export const olderThan24hrAgo = (ts: number): boolean => {
    const oneDay = 60 * 60 * 24 * 1000;
    const oneDayAgo = Date.now() - oneDay;
    return ts < oneDayAgo;
};
